module.exports = __webpack_public_path__ + "img/childrenPoolAndPlayArea.071ac3ef.png";